<div *transloco="let t">
  <app-dialog-title>
    {{ isCreate ? t("settings.add") : t("settings.update") }}
    {{ "settings.template-type" | transloco }}
  </app-dialog-title>

  <mat-dialog-content>
    <form [formGroup]="form" class="ui form">
      <div class="content">
        <div class="field">
          <label>{{ "settings.template-type" | transloco }}</label>
          <input formControlName="templateTypeName" class="form-control" />
        </div>
        <div class="field">
          <label>{{ "settings.module" | transloco }}</label>
          <mat-select
            class="selection form-control small"
            (selectionChange)="templateTypeModuleChanged()"
            formControlName="templateTypeModule"
          >
            @for (option of templateTypeModuleList; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
            }
          </mat-select>
        </div>
        <div class="field">
          <label>{{ "settings.group" | transloco }}</label>
          <mat-select
            class="selection form-control small"
            [disabled]="templateTypeModule.value !== 'TAXRETURN'"
            formControlName="templateTypeGroup"
          >
            @for (option of templateTypeGroupList; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
            }
          </mat-select>
        </div>
        <div class="field">
          <label>{{ "settings.order" | transloco }}</label>
          <input formControlName="templateTypeOrder" class="form-control" />
        </div>
        <div class="field">
          <label>{{ "settings.signature-required" | transloco }}</label>
          <input
            type="checkbox"
            formControlName="signatureRequired"
            class="form-control"
          />
        </div>
        <div class="field">
          <label>{{ "settings.alias" | transloco }}</label>
          <input formControlName="alias" class="form-control" />
        </div>
        <!-- <div class="field">
        <label>{{ 'settings.otWebSheetDisplayName' | transloco }}</label>
        <input formControlName="otWebSheetDisplayName" class="form-control" />
      </div> -->
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <a class="go-back cancel" (click)="onClose()">{{
      "settings.cancel" | transloco
    }}</a>
    @if (!isProductionMode) {
    <button
      [disabled]="!form.valid"
      (click)="saveTemplateType()"
      class="ui primary button"
    >
      {{ isCreate ? t("settings.add") : t("settings.update") }}
      {{ "settings.template-type" | transloco }}
    </button>
    }
  </mat-dialog-actions>
</div>
